var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('error-card',{attrs:{"message":_vm.$t('Page not found'),"code":_vm.code}})}
var staticRenderFns = []

export { render, staticRenderFns }